module.exports = "/_next/static/images/022e76a20f3f1b8303fe5116174ce022-mgm-xs-2.png";